<template>
    <div class="d-flex flex-column gap-2">
        <div class="table-responsive p-0">
            <table class="table" :class="tableName">
                <thead>
                    <tr v-if="thead.length > 0">
                        <th scope="col" v-for="(item, index) in thead" :key="index" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">{{ item }}</th>
                    </tr>
                    <slot v-if="thead.length < 1" name="thead"></slot>
                </thead>
                <tbody>
                    <slot name="tbody"></slot>
                </tbody>
                <tfoot>
                    <slot name="tfoot"></slot>
                </tfoot>
            </table>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default{
    name: "ListView",
    props: {
        thead: {
            type: Array,
            default: () => [],
        },
        enablePagination: {
            type: Boolean,
            default: false,
        },
        nextPage: {
            type: Function,
            default: function () {},
        },
        prevPage: {
            type: Function,
            default: function () {},
        },
        tableName: {
            type: String,
        }
    }
}
</script>